function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Vector2ds } from "./Vector2d";
import { Rectangle } from "@stage/math";
export var BoundingRects = /*#__PURE__*/function () {
  function BoundingRects() {
    _classCallCheck(this, BoundingRects);
  }
  _createClass(BoundingRects, null, [{
    key: "empty",
    value: function empty() {
      return {
        left: Infinity,
        top: Infinity,
        right: -Infinity,
        bottom: -Infinity
      };
    }
    /**
     * box占据边界
     * @param box
     *
     */
  }, {
    key: "boundingBox",
    value: function boundingBox(box) {
      var x = box.x,
        y = box.y,
        width = box.width,
        height = box.height,
        rotate = box.rotate;
      var mw = width / 2;
      var mh = height / 2;
      var point = {
        x: 0,
        y: 0
      };
      var vertexVec = {
        lt: Vector2ds.rotate(point, rotate, {
          x: mw,
          y: mh
        }),
        rt: Vector2ds.rotate(point, rotate, {
          x: -mw,
          y: mh
        }),
        lb: Vector2ds.rotate(point, rotate, {
          x: mw,
          y: -mh
        }),
        rb: Vector2ds.rotate(point, rotate, {
          x: -mw,
          y: -mh
        })
      };
      var rectRotatedVertexVec2 = {
        lt: Vector2ds.translate({
          x: x,
          y: y
        }, vertexVec.lt),
        rt: Vector2ds.translate({
          x: x + width,
          y: y
        }, vertexVec.rt),
        lb: Vector2ds.translate({
          x: x,
          y: y + height
        }, vertexVec.lb),
        rb: Vector2ds.translate({
          x: x + width,
          y: y + height
        }, vertexVec.rb)
      };
      var left = Math.min(rectRotatedVertexVec2.lt.x, rectRotatedVertexVec2.rt.x, rectRotatedVertexVec2.lb.x, rectRotatedVertexVec2.rb.x);
      var top = Math.min(rectRotatedVertexVec2.lt.y, rectRotatedVertexVec2.rt.y, rectRotatedVertexVec2.lb.y, rectRotatedVertexVec2.rb.y);
      var right = Math.max(rectRotatedVertexVec2.lt.x, rectRotatedVertexVec2.rt.x, rectRotatedVertexVec2.lb.x, rectRotatedVertexVec2.rb.x);
      var bottom = Math.max(rectRotatedVertexVec2.lt.y, rectRotatedVertexVec2.rt.y, rectRotatedVertexVec2.lb.y, rectRotatedVertexVec2.rb.y);
      return new Rectangle(left, top, right - left, bottom - top);
    }
  }, {
    key: "merge",
    value: function merge() {
      for (var _len = arguments.length, rects = new Array(_len), _key = 0; _key < _len; _key++) {
        rects[_key] = arguments[_key];
      }
      return rects.reduce(function (value, item) {
        return {
          left: Math.min(value.left, item.left),
          top: Math.min(value.top, item.top),
          right: Math.max(value.right, item.right),
          bottom: Math.max(value.bottom, item.bottom)
        };
      }, {
        left: Infinity,
        top: Infinity,
        right: -Infinity,
        bottom: -Infinity
      });
    }
  }]);
  return BoundingRects;
}();